<template>
  <el-drawer title="发起审批" :visible.sync="drawer" :modal-append-to-body="false" append-to-body destroy-on-close :wrapperClosable="false" custom-class="widthCommon">
    <el-form ref="addForm" status-icon :model="addForm" :rules="rules" label-position="left" label-width="83px" size="small" class="mx-20-1 bg-#fff py-20 pr-30">
      <el-form-item label="请假类型：" prop="vacationType">
        <el-select v-model="addForm.vacationType" filterable value-key="vacationType" clearable placeholder="选择请假类型" style="width: 100%">
          <el-option
            v-for="item in indexThis.vacationTypeLists"
            :key="item.vacationTypeId"
            :label="item.vacationTypeName"
            :value="{ vacationType: item.vacationTypeId, vacationName: item.vacationTypeName }"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="请假单位：" prop="timeUnit">
        <el-radio-group v-model="addForm.timeUnit" @change="changeTimeUnit">
          <el-radio :label="1">按小时请假</el-radio>
          <el-radio :label="2">按天请假</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="开始时间：" prop="beginTime" class="row-form-item">
        <el-date-picker
          v-model="addForm.beginTime"
          value-format="yyyy-MM-dd HH:mm:ss"
          type="date"
          placeholder="选择日期"
          class="flex-1"
          @change="handlerDateIsAfter(addForm, 'beginTime', 'endTime'), timeChange()"
        ></el-date-picker>
        <div class="gap"></div>
        <template v-if="addForm.timeUnit == 1">
          <el-form-item prop="beginHourTime" class="flex-1">
            <el-time-picker
              v-model="addForm.beginHourTime"
              format="HH:mm"
              value-format="HH:mm:ss"
              placeholder="请选择时间"
              @change="timeChange(), beginHourTimeChange()"
            ></el-time-picker>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item prop="beginStatus" :rules="rules.beginHourTime" class="flex-1">
            <el-select v-model="addForm.beginStatus" filterable clearable placeholder="请选择时间" @change="timeChange">
              <el-option v-for="item in enumList.timeArray" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </template>
      </el-form-item>
      <el-form-item label="结束时间：" prop="endTime" class="row-form-item">
        <el-date-picker
          v-model="addForm.endTime"
          :disabled="!addForm.beginTime || addForm.timeUnit == 1"
          :picker-options="pickerOptionsDate(addForm.beginTime, 'only')"
          :default-value="defaultDatePickerDate(addForm.beginTime)"
          type="date"
          value-format="yyyy-MM-dd HH:mm:ss"
          placeholder="选择日期"
          class="flex-1"
          @change="timeChange"
        ></el-date-picker>
        <div class="gap"></div>
        <template v-if="addForm.timeUnit == 1">
          <el-form-item prop="endHourTime" class="flex-1">
            <el-time-picker
              v-model="addForm.endHourTime"
              format="HH:mm"
              value-format="HH:mm:ss"
              :picker-options="{
                selectableRange: `${addForm.beginHourTime}:00 - 23:59:59`,
              }"
              placeholder="请选择时间"
              @change="timeChange"
            ></el-time-picker>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item prop="endStatus" :rules="rules.endHourTime" class="flex-1">
            <el-select v-model="addForm.endStatus" filterable clearable placeholder="请选择时间" @change="timeChange">
              <el-option v-for="item in enumList.timeArray" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>
        </template>
      </el-form-item>
      <el-form-item label="请假时长：" prop="vacationTime">
        <el-input v-angle="addForm.vacationTime" disabled v-model="addForm.vacationTime" placeholder="根据开始时间、结束时间，系统自动计算" />
      </el-form-item>
      <el-form-item label="请假事由：" prop="vacationReason">
        <el-input v-angle="addForm.vacationReason" v-model="addForm.vacationReason" placeholder="填写请假事由" :rows="4" maxlength="70" type="textarea" show-word-limit clearable />
      </el-form-item>
      <el-form-item label="附件：" prop="annexUrl" label-width="73px" style="margin-left: 10px">
        <el-upload
          class="flex items-start flex-column"
          accept=".jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.pdf"
          :action="`/api/estate/v1/common/uploadFile?token=${token}&communityId=0`"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          multiple
          :limit="3"
        >
          <el-button size="small" type="primary" class="mr-8">选择附件</el-button>
        </el-upload>
        <div class="el-upload__tip">最多3个，不超过2M，格式为jpg/jpeg/png/doc/docx/xls/xlsx/pdf</div>
      </el-form-item>
    </el-form>
    <FixedTwoButton activeClass="widthCommon">
      <ELButton size="small" describe="重置" :myFunction="resetForm" />
      <ELButton size="small" describe="提交" isAsync :myFunction="submitForm" type="primary" />
    </FixedTwoButton>
  </el-drawer>
</template>

<script>
import { getToken } from '@/utils/auth'
import { submitFlowVacationApply, calcVacationDuration } from '@/api/workflow'
import dayjs from 'dayjs'
import formatData from '@/utils/formatRequestData'

export default {
  inject: ['indexThis'],
  data() {
    return {
      drawer: false,
      addForm: {
        vacationType: '',
        timeUnit: 1,
        beginTime: '',
        beginHourTime: '',
        beginStatus: '',
        endTime: '',
        endHourTime: '',
        endStatus: '',
        vacationTime: '',
        vacationReason: '',
        annexUrl: [],
      },
      rules: {
        vacationType: [{ required: true, message: '请假类型不能为空', trigger: 'change' }],
        timeUnit: [{ required: true, message: '请假单位不能为空', trigger: 'change' }],
        beginTime: [{ required: true, message: '开始日期不能为空', trigger: 'change' }],
        beginHourTime: [{ required: true, message: '开始时间不能为空', trigger: 'change' }],
        endHourTime: [{ required: true, message: '开始时间不能为空', trigger: 'change' }],
        endTime: [{ required: true, message: '结束日期不能为空', trigger: 'change' }],
        vacationTime: [{ required: true, message: '请假时长不能为空', trigger: 'change' }],
        vacationReason: [{ required: true, message: '请假事由不能为空', trigger: 'change' }],
      },
    }
  },
  computed: {
    token() {
      return getToken()
    },
  },
  methods: {
    async submitForm() {
      const valid = await this.$refs.addForm.validate().catch(() => {})
      if (!valid) return false
      const format = formatData(this.addForm)
      const { data: res } = await submitFlowVacationApply({
        ...format,
        beginTime: format.timeUnit === 1 ? `${dayjs(format.beginTime).format('YYYY-MM-DD')} ${format.beginHourTime}` : format.beginTime,
        endTime: format.timeUnit === 1 ? `${dayjs(format.endTime).format('YYYY-MM-DD')} ${format.endHourTime}` : format.endTime,
      })

      if (!res) return this.$message.error('发起失败')
      this.$message.success('发起成功')
      this.indexThis.init()
      this.resetForm()
      this.drawer = false
    },
    resetForm() {
      this.$refs.addForm.resetFields()
    },

    // 移除上传的文件
    handleRemove(file, fileList) {
      this.addForm.annexUrl = fileList.map(item => item.response.data.visitUrl)
    },

    handleSuccess(res, file, fileList) {
      if (res.errCode !== 0) {
        this.handleRemove(file, fileList)
        return this.$message.error(res.errMsg)
      }
      this.addForm.annexUrl = fileList.map(item => item.response.data.visitUrl)
    },

    changeTimeUnit(e) {
      this.addForm.beginStatus = ''
      this.addForm.endStatus = ''
      this.addForm.beginHourTime = ''
      this.addForm.endHourTime = ''
    },

    timeChange(e) {
      const { timeUnit, beginTime, beginStatus, endStatus, beginHourTime, endTime, endHourTime } = this.addForm
      if (timeUnit == 1 && beginTime) this.addForm.endTime = beginTime
      if (timeUnit == 1 && (!beginHourTime || !endHourTime || !beginTime || !endTime)) return
      if (timeUnit == 2 && (!beginStatus || !endStatus || !beginTime || !endTime)) return
      const query =
        timeUnit === 1
          ? {
              timeUnit,
              beginTime: `${dayjs(beginTime).format('YYYY-MM-DD')} ${beginHourTime}`,
              endTime: `${dayjs(endTime).format('YYYY-MM-DD')} ${endHourTime}`,
            }
          : {
              timeUnit,
              beginTime,
              endTime,
              beginStatus,
              endStatus,
            }
      this.calcVacationDuration(query)
    },

    // 计算请假时长
    async calcVacationDuration(params = {}) {
      let { data } = await calcVacationDuration(params)
      if (data) {
        this.addForm.vacationTime = data
      } else {
        this.addForm.beginTime = ''
        this.addForm.endTime = ''
        this.addForm.endHourTime = ''
        this.addForm.beginHourTime = ''
        this.addForm.beginStatus = ''
        this.addForm.endStatus = ''
      }
    },

    beginHourTimeChange() {
      if (this.addForm.beginHourTime <= this.addForm.endHourTime) {
        this.addForm.endHourTime = '' // 清空无效的选择
      }
    },
  },
}
</script>

<style lang="less" scoped>
.row-form-item {
  ::v-deep .el-form-item__content {
    display: flex;
    margin-left: 0px !important;
  }
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 0px !important;
  }
}
.gap {
  width: 8px;
}
::v-deep .el-upload {
  width: auto !important;
  height: auto !important;
  border: none !important;
}
.el-upload__tip {
  color: #606266 !important;
  margin-top: 0 !important;
}
::v-deep .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100% !important;
}
</style>
